import { WTBAction } from "views/wtb/WhosTheBotReducer";
import { WTBProtocol, WTBProtocolData } from "views/wtb/WTBProtocol";
import SocketService from "network/SocketService";
import UserSession from "network/UserSession";

export class WhosTheBotSocketService {
  private dispatch: React.Dispatch<WTBAction>;
  private socket = SocketService.getInstance();

  constructor(dispatch: React.Dispatch<WTBAction>) {
    this.dispatch = dispatch;
  }

  public initializeListeners() {
    // 라운드 시작
    this.socket.on(
      WTBProtocol.ROUND_START,
      (data: WTBProtocolData[typeof WTBProtocol.ROUND_START]) => {
        this.dispatch({
          type: "SOCKET_ROUND_START",
          payload: data,
        });
      }
    );

    // 시간 업데이트
    // this.socket.on(
    //   WTBProtocol.TIME_UPDATE,
    //   (data: WTBProtocolData[typeof WTBProtocol.TIME_UPDATE]) => {
    //     console.log(data.leftTime);
    //     this.dispatch({
    //       type: "SOCKET_TIME_UPDATE",
    //       payload: data,
    //     });
    //   }
    // );

    // 답변 제출
    this.socket.on(
      WTBProtocol.ANSWER_SUBMITTED,
      (data: WTBProtocolData[typeof WTBProtocol.ANSWER_SUBMITTED]) => {
        this.dispatch({
          type: "SOCKET_ANSWER_SUBMITTED",
          payload: data,
        });
      }
    );

    // 투표 시작 (답변 공개와 동시에)
    this.socket.on(
      WTBProtocol.VOTING_START,
      (data: WTBProtocolData[typeof WTBProtocol.VOTING_START]) => {
        this.dispatch({
          type: "SOCKET_VOTING_START",
          payload: data,
        });
      }
    );

    // 라운드 결과
    this.socket.on(
      WTBProtocol.VOTE_RESULT,
      (data: WTBProtocolData[typeof WTBProtocol.VOTE_RESULT]) => {
        this.dispatch({
          type: "SOCKET_VOTE_RESULT",
          payload: data,
        });
      }
    );

    // AI 투표 시작
    this.socket.on(
      WTBProtocol.AI_VOTING_START,
      (data: WTBProtocolData[typeof WTBProtocol.AI_VOTING_START]) => {
        this.dispatch({
          type: "SOCKET_AI_VOTING_START",
          payload: data,
        });
      }
    );

    // 최종 결과
    this.socket.on(
      WTBProtocol.FINAL_RESULTS,
      (data: WTBProtocolData[typeof WTBProtocol.FINAL_RESULTS]) => {
        console.log("WTB FINAL_RESULTS received:", data);
        this.dispatch({
          type: "SOCKET_FINAL_RESULTS",
          payload: data,
        });
      }
    );

    // 게임 상태 동기화 (재연결 시)
    this.socket.on(
      WTBProtocol.SYNC_GAME_STATE,
      (data: WTBProtocolData[typeof WTBProtocol.SYNC_GAME_STATE]) => {
        console.log("WTB SYNC_GAME_STATE received:", data);

        // 페이즈별로 적절한 액션 디스패치
        switch (data.currentPhase) {
          case "final":
            if (data.finalResults) {
              this.dispatch({
                type: "SOCKET_FINAL_RESULTS",
                payload: {
                  ...data.finalResults,
                  players: data.players,
                },
              });
            }
            break;
          case "aiVoting":
            this.dispatch({
              type: "SOCKET_AI_VOTING_START",
              payload: {
                leftTime: data.leftTime,
                players: data.players,
              },
            });
            break;
          case "answer":
          case "voting":
          case "results":
            // 현재 라운드 상태 복원
            this.dispatch({
              type: "SOCKET_ROUND_START",
              payload: {
                round: data.currentRound,
                totalRounds: data.totalRounds,
                question: data.question,
                leftTime: data.leftTime,
                players: data.players,
              },
            });
            break;
        }
      }
    );

    // 에러 처리
    this.socket.on(
      WTBProtocol.ERROR,
      (error: WTBProtocolData[typeof WTBProtocol.ERROR]) => {
        console.error("WTB Socket Error:", error);
        // TODO: 에러 처리 로직 추가
      }
    );
  }

  public cleanup() {
    this.socket.off(WTBProtocol.ROUND_START);
    // this.socket.off(WTBProtocol.TIME_UPDATE);
    this.socket.off(WTBProtocol.ANSWER_SUBMITTED);
    this.socket.off(WTBProtocol.VOTING_START);
    this.socket.off(WTBProtocol.VOTE_RESULT);
    this.socket.off(WTBProtocol.ERROR);
    this.socket.off(WTBProtocol.AI_VOTING_START);
    this.socket.off(WTBProtocol.FINAL_RESULTS);
    this.socket.off(WTBProtocol.SYNC_GAME_STATE);
  }

  public submitAnswer(answer: string, playerId: number) {
    this.socket.emit(WTBProtocol.ANSWER_SUBMITTED, { answer, playerId });
  }

  public submitVote(playerId: number) {
    const myId = UserSession.getInstance().getUserId();
    this.socket.emit(WTBProtocol.VOTE_SUBMITTED, {
      playerId, // 투표 대상 플레이어 ID
      voterId: myId, // 투표하는 사람의 ID
    });
  }

  public submitFinalVote(playerId: number) {
    const myId = UserSession.getInstance().getUserId();
    this.socket.emit(WTBProtocol.AI_VOTE_SUBMITTED, {
      voterId: myId,
      votedPlayerId: playerId,
    });
  }
}
